/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nb-theme-default   [_nghost-%COMP%]   nb-card[_ngcontent-%COMP%]{max-width:250px;max-height:500px}"];
export { styles as styles };
